import React, { useContext } from 'react'

import { Template } from '../../components/template'
import { TemplateContext } from '../../components/template/context'
import Button from '../../components/Button'
import { MobileHeader } from '../../components/MobileHeader'

import { useEligibilityResponse } from './hooks'
import * as S from './styles'

export const EligibilityResponse = () => {
  const { setIsLoadingGlobal } = useContext(TemplateContext)
  const [titleMessage, message, showButton, messagePt2] = useEligibilityResponse(setIsLoadingGlobal)

  return (
    <Template haveHeader>
      <MobileHeader />
      <S.Container>
        <S.Title>{titleMessage}</S.Title>

        <S.Subtitle>{message}</S.Subtitle>

        <S.Subtitle>{messagePt2}</S.Subtitle>

        {showButton && (
          <S.MobileButtonWrapper>
            <Button
              text="Entrar em contato"
              footerButton
              onClick={() =>
                window
                  .open(
                    'https://api.whatsapp.com/send?phone=5511957712414&text=Oi%2C%20Provi%21%20Pode%20me%20ajudar%20?',
                    '_blank',
                  )
                  .focus()
              }
            />
          </S.MobileButtonWrapper>
        )}
      </S.Container>
    </Template>
  )
}
